module.exports = __webpack_public_path__ + "img/text.d8394dc9.png";